// extracted by mini-css-extract-plugin
export default {"generalDataFiltersContainer":"generalDataFilters_generalDataFiltersContainer__i82fb","collapsableComponent":"generalDataFilters_collapsableComponent__9Qe6l"};